import { useEffect } from "react";

import { Tabs } from "@newsela/angelou";

import { useConceptTaxonomyProvider } from "@/search/Langston/ConceptTaxonomyProvider";
import { SearchTags } from "../SearchTags";
import { TabPanelProperties } from "../../Concepts.interface";
import {
  modalDescriptionCss,
  tabPanelAdjustmentsCss,
} from "./TaxonomyModalTabs.styles";

interface ITaxonomyModalTabsProps {
  panelData: TabPanelProperties[];
  handleSearch: (query: string) => void;
}

export const TaxonomyModalTabs = ({
  panelData,
  handleSearch,
}: ITaxonomyModalTabsProps) => {
  const { isTabletOrMobileView } = useConceptTaxonomyProvider();

  useEffect(() => {
    panelData.forEach((panel) => {
      const tabButton = document.getElementById(`${panel.panelId}_tab`);
      if (tabButton?.parentElement) {
        tabButton.parentElement.setAttribute(
          "data-qa-selector",
          `taxonomy-tab-${panel.panelId}`,
        );
      }
    });
  }, [panelData]);

  const handleTabClick = () => {
    setTimeout(() => {
      const container = document.getElementById("modal_description");
      if (container) {
        container.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, 0);
  };

  return (
    <div id="modal_description" css={modalDescriptionCss}>
      {!isTabletOrMobileView && <SearchTags onSearch={handleSearch} />}
      <Tabs
        horizontalSwitch="sm"
        initialPanelId="all"
        panels={panelData}
        renderTabsAsButtons
        flavor="underlined"
        __cssFor={{
          root: tabPanelAdjustmentsCss,
        }}
        onClick={handleTabClick}
        dataProps={{
          "data-qa-selector": "taxonomy-subject-tabs",
          "data-testid": "taxonomy-subject-tabs",
        }}
      />
    </div>
  );
};
